import * as tslib_1 from "tslib";
/**
 * @public
 */
var BinaryDecoder = /** @class */function () {
  function BinaryDecoder(arrayBuffer, index) {
    if (index === void 0) {
      index = 0;
    }
    this.arrayBuffer = arrayBuffer;
    this.index = index;
    this.dataView = new DataView(arrayBuffer);
  }
  BinaryDecoder.prototype.getInt8 = function () {
    var result = this.dataView.getInt8(this.index);
    this.index += 1;
    return result;
  };
  BinaryDecoder.prototype.getUint8 = function () {
    var result = this.dataView.getUint8(this.index);
    this.index += 1;
    return result;
  };
  BinaryDecoder.prototype.getInt16 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getInt16(this.index, littleEndian);
    this.index += 2;
    return result;
  };
  BinaryDecoder.prototype.getUint16 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getUint16(this.index, littleEndian);
    this.index += 2;
    return result;
  };
  BinaryDecoder.prototype.getInt32 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getInt32(this.index, littleEndian);
    this.index += 4;
    return result;
  };
  BinaryDecoder.prototype.getUint32 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getUint32(this.index, littleEndian);
    this.index += 4;
    return result;
  };
  BinaryDecoder.prototype.getFloat32 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getFloat32(this.index, littleEndian);
    this.index += 4;
    return result;
  };
  BinaryDecoder.prototype.getFloat64 = function (littleEndian) {
    if (littleEndian === void 0) {
      littleEndian = true;
    }
    var result = this.dataView.getFloat64(this.index, littleEndian);
    this.index += 8;
    return result;
  };
  BinaryDecoder.prototype.getString = function (length) {
    var binary = this.getBinary(length);
    var array = [].slice.call(binary);
    return String.fromCharCode.apply(String, tslib_1.__spread(array));
  };
  BinaryDecoder.prototype.getBinary = function (length) {
    if (length === undefined) {
      var result = new Uint8Array(this.arrayBuffer, this.index);
      this.index = this.arrayBuffer.byteLength;
      return result;
    } else {
      var result = new Uint8Array(this.arrayBuffer, this.index, length);
      this.index += length;
      return result;
    }
  };
  return BinaryDecoder;
}();
export { BinaryDecoder };
/**
 * @public
 */
export var BinaryEncoder = {
  fromInt8: function fromInt8() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      values[_i] = arguments[_i];
    }
    return new Uint8Array(new Int8Array(values).buffer);
  },
  fromUint8: function fromUint8() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      values[_i] = arguments[_i];
    }
    return new Uint8Array(values);
  },
  fromInt16: function fromInt16(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 2;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setInt16(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromUint16: function fromUint16(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 2;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setUint16(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromInt32: function fromInt32(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 4;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setInt32(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromUint32: function fromUint32(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 4;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setUint32(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromFloat32: function fromFloat32(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 4;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setFloat32(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromFloat64: function fromFloat64(littleEndian) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      values[_i - 1] = arguments[_i];
    }
    var offset = 8;
    var dataView = new DataView(new Uint8Array(values.length * offset).buffer);
    for (var i = 0; i < values.length; i++) {
      dataView.setFloat64(i * offset, values[i], littleEndian);
    }
    return new Uint8Array(dataView.buffer);
  },
  fromString: function fromString(unicode) {
    var uint8Array = new Uint8Array(unicode.length);
    for (var i = 0; i < unicode.length; i++) {
      uint8Array[i] = unicode.charCodeAt(i);
    }
    return uint8Array;
  },
  concat: function concat() {
    var uint8Arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      uint8Arrays[_i] = arguments[_i];
    }
    var e_1, _a;
    var length = uint8Arrays.reduce(function (p, c) {
      return p + c.length;
    }, 0);
    var result = new Uint8Array(length);
    var index = 0;
    try {
      for (var uint8Arrays_1 = tslib_1.__values(uint8Arrays), uint8Arrays_1_1 = uint8Arrays_1.next(); !uint8Arrays_1_1.done; uint8Arrays_1_1 = uint8Arrays_1.next()) {
        var uint8Array = uint8Arrays_1_1.value;
        result.set(uint8Array, index);
        index += uint8Array.length;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (uint8Arrays_1_1 && !uint8Arrays_1_1.done && (_a = uint8Arrays_1.return)) _a.call(uint8Arrays_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return result;
  }
};